/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Multifactor_2faInputs */

const en_multifactor_2fa = /** @type {(inputs: Multifactor_2faInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multi-Factor (2FA)`)
};

const es_multifactor_2fa = /** @type {(inputs: Multifactor_2faInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multifactor (2FA)`)
};

const fr_multifactor_2fa = /** @type {(inputs: Multifactor_2faInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multifacteur (2FA)`)
};

const de_multifactor_2fa = /** @type {(inputs: Multifactor_2faInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multi-Faktor (2FA)`)
};

const ja_multifactor_2fa = /** @type {(inputs: Multifactor_2faInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`多要素認証 (2FA)`)
};

const zh_multifactor_2fa = /** @type {(inputs: Multifactor_2faInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`多因素认证 (2FA)`)
};

const ar_multifactor_2fa = /** @type {(inputs: Multifactor_2faInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مصادقة متعددة العوامل (2FA)`)
};

const id_multifactor_2fa = /** @type {(inputs: Multifactor_2faInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autentikasi Multi-Faktor (2FA)`)
};

const it_multifactor_2fa = /** @type {(inputs: Multifactor_2faInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autenticazione a Più Fattori (2FA)`)
};

const ru_multifactor_2fa = /** @type {(inputs: Multifactor_2faInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Двухфакторная авторизация (2FA)`)
};

const pt_multifactor_2fa = /** @type {(inputs: Multifactor_2faInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Múltiplos Fatores (2FA)`)
};

const ko_multifactor_2fa = /** @type {(inputs: Multifactor_2faInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다중 요소 인증 (2FA)`)
};

/**
* | output |
* | --- |
* | "Multi-Factor (2FA)" |
*
* @param {Multifactor_2faInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const multifactor_2fa = /** @type {((inputs?: Multifactor_2faInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Multifactor_2faInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_multifactor_2fa(inputs)
	if (locale === "es") return es_multifactor_2fa(inputs)
	if (locale === "fr") return fr_multifactor_2fa(inputs)
	if (locale === "de") return de_multifactor_2fa(inputs)
	if (locale === "ja") return ja_multifactor_2fa(inputs)
	if (locale === "zh") return zh_multifactor_2fa(inputs)
	if (locale === "ar") return ar_multifactor_2fa(inputs)
	if (locale === "id") return id_multifactor_2fa(inputs)
	if (locale === "it") return it_multifactor_2fa(inputs)
	if (locale === "ru") return ru_multifactor_2fa(inputs)
	if (locale === "pt") return pt_multifactor_2fa(inputs)
	return ko_multifactor_2fa(inputs)
});